module.exports = __webpack_public_path__ + "static/media/ex3.45a09120.png";